export default __webpack_public_path__ + "static/media/reset.4a7e48d5.svg";